import { CommonModule } from "@angular/common";
import { Component, forwardRef, inject, Input, OnInit, OnDestroy } from "@angular/core";
import { FormControl, NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { TranslateModule } from "@ngx-translate/core";
import { NgxFileDropEntry, NgxFileDropModule } from "ngx-file-drop";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { GenerateRandom } from "src/utils/random";
import { KeeniconComponent } from "../keenicon/keenicon.component";

@Component({
  selector: "app-file-upload",
  templateUrl: "./file-upload.component.html",
  styleUrls: ["./file-upload.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploadComponent),
      multi: true,
    },
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    NgxFileDropModule,
    KeeniconComponent,
  ],
})
export class FileUploadComponent implements OnInit, OnDestroy {
  @Input() name = GenerateRandom(6);
  @Input() label: string;
  @Input() accept = ".jpg , .png , .pdf , .svg , .csv";
  @Input() limitLabel: string;
  @Input() limitSize = 100000000; // 100MB
  @Input() multiple = false;

  subscription: Subscription;
  files: NgxFileDropEntry[] = [];
  file: File | null;

  displayFile = "";
  hasDropZoneOver = false;

  form = new FormControl();

  private translate = inject(TranslateService);

  @Input()
  set isDisabled(value: boolean) {
    if (value) {
      this.form.disable();
    } else {
      this.form.enable();
    }
  }

  @Input() set fileName(value: string) {
    this.displayFile = value;
  }

  onChange = (value: string) => {};
  onTouched = (value: string) => {};

  ngOnInit(): void {
    this.subscription = this.form.valueChanges
      .pipe(distinctUntilChanged())
      .subscribe((val) => {
        const value = this.form.value;
        this.onChange(value);
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  writeValue(value: any): void {
    if ((value === null || value === undefined || value === "") && this.file !== null) {
      this.removeFile();
    }
    this.form.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {}

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    this.hasDropZoneOver = false;

    const fileEntry = files[0].fileEntry as FileSystemFileEntry;
    const reader = new FileReader();
    fileEntry.file((file: File) => {
      if (file.size > this.limitSize) {
        // const title = this.translate.instant('SWEETALERT.WARNING_IMAGE_SIZE_TITLE');
        // const text = this.translate.instant('SWEETALERT.WARNING_IMAGE_SIZE_TEXT', { value: this.limitLabel['value'], unit: this.limitLabel['unit'] });
        // this.swalService.swalWarning(title, text);
      } else {
        reader.readAsDataURL(file);
        // reader.onload = () => {
        //   this.imageUrl$.next(reader.result);
        // };
        this.form.setValue(file);
        this.file = file;
        this.displayFile = file.name;
      }
    });
  }

  removeFile(event?: MouseEvent) {
    event?.stopPropagation();
    this.form.reset();
    this.files.splice(0, 1);
    this.file = null;
    this.displayFile = "";
    // this.imageUrl$.next(null);
    // this.onDeleteImage.emit();
  }
}
